import {
  baseFields,
  couponFields,
  FormModel,
  onlineFlags,
  PosFields,
  templateConstraintFields,
} from '../index'

export function getFormModelKeys(): (keyof FormModel)[] {
  return [
    ...baseFields,
    'discount',
    ...onlineFlags,
    'instoreRedemptionType',
    'availableCustomerSupport',
    'images',
    ...couponFields,
    'posFields',
    'productIds',
    ...templateConstraintFields,
  ]
}

export function getPosFieldKeys(): (keyof PosFields)[] {
  return ['instoreRedemptionType', 'productIds', ...couponFields]
}
